import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import flecha from "../../../../static/img/flecha.svg";
import back from "../../../../static/img/back.svg";
import smallsearch from "../../../../static/img/searchiconsmall.svg";
import { fetchObjetivos, asociarObjetivo } from "../../../../services/deportistaApi";
import LoadingScreen from "../../../../static/assets/loadingScreen/loadingScreen";
import { getUserId } from "../../../../services/utilsApi";
import CuadroTexto from "../../../../static/assets/cuadroTexto/cuadroTexto";

const DeportistaObjetivo = () => {
  const [objetivos, setObjetivos] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState("");
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("no-footer-padding");

    const loadObjetivos = async () => {
      try {
        const response = await fetchObjetivos();
        setObjetivos(response.data.objetivos);
      } catch (err) {
        setErrorMessage("Error al cargar los objetivos. Inténtalo de nuevo más tarde.");
      } finally {
        setLoading(false);
      }
    };

    loadObjetivos();

    return () => {
      document.body.classList.remove("no-footer-padding");
    };
  }, []);

  const handleGoalSelect = (objetivo) => {
    setSelectedGoal(objetivo);
  };

  const handleConfirm = async () => {
    if (!selectedGoal) {
      setErrorMessage("Por favor, selecciona un objetivo antes de continuar.");
      return;
    }

    setConfirming(true);
    try {
      const userIdResponse = await getUserId();
      const userId = userIdResponse.data.user_id;

      const objetivo = objetivos.find((obj) => obj.nombre === selectedGoal);
      if (objetivo) {
        const payload = { id_objetivo: objetivo.id_objetivo };
        await asociarObjetivo(userId, payload);

        navigate("/dashboard");
      } else {
        throw new Error("Objetivo seleccionado no válido.");
      }
    } catch (err) {
      console.error("Error al asociar el objetivo:", err);
      setErrorMessage("Ocurrió un error al asociar tu objetivo. Intenta nuevamente.");
    } finally {
      setConfirming(false);
    }
  };

  const handleBack = () => {
    navigate("/perfil");
  };

  const filteredObjetivos = objetivos.filter((objetivo) =>
    objetivo.nombre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="objetivo-page">
      {errorMessage && (
        <CuadroTexto
          message={errorMessage}
          onAccept={() => setErrorMessage("")}
          showCancel={false}
        />
      )}

      <div className="objetivo-header">
        <button className="objetivo-back-button" onClick={handleBack}>
          <img src={back} alt="Regresar" />
        </button>
        <h4 className="objetivo-header-tittle">Objetivo</h4>
      </div>
      <h2 className="objetivo-title">Selecciona cuál será tu objetivo</h2>
      <div className="selected-goal-container">
        {selectedGoal ? (
          <div className="selected-goal">{selectedGoal}</div>
        ) : (
          <div className="placeholder-goal">Objetivo seleccionado</div>
        )}
        <h4 className="objetivos-list-title">Todos los objetivos:</h4>
      </div>
      <div className="objetivo-search-bar">
        <div className="search-icon">
          <img src={smallsearch} alt="Buscar"/>
        </div>
        <input
          type="text"
          placeholder="Buscar"
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="objetivos-list">
        {filteredObjetivos.length > 0 ? (
          filteredObjetivos.map((objetivo) => (
            <button
              key={objetivo.id_objetivo}
              className={`objetivo-button ${selectedGoal === objetivo.nombre ? "selected" : ""}`}
              onClick={() => handleGoalSelect(objetivo.nombre)}
            >
              {objetivo.nombre}
              <img className="flecha-icon" alt="Seleccionar" src={flecha} />
            </button>
          ))
        ) : (
          <p className="no-results">No se encontraron objetivos.</p>
        )}
      </div>

      <div className="terms-container">
        <p>
          Al presionar el botón de <span className="confirm-text">confirmación</span>, reconoces y aceptas los{" "}
          <a href="/terms" target="_blank" rel="noopener noreferrer">
            Términos y Condiciones de Uso
          </a>
          .
        </p>
      </div>

      {confirming ? (
        <LoadingScreen />
      ) : (
        <button
          className={`confirm-button ${selectedGoal ? "" : "disabled"}`}
          onClick={handleConfirm}
          disabled={!selectedGoal}
        >
          Confirmar
        </button>
      )}
    </div>
  );
};

export default DeportistaObjetivo;
